<template>
    <div class="bottom-bar pfixed bottom-left bottom-right h-7 bt-1">
        <div class="flex-level container-medium mx-auto my-4 px-4">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
    .bottom-bar {
        z-index:1;
        background: white;
    }
</style>
